import { handleResponse } from './handleResponse';
import apiAxios from './apiAxios';
import { CompanyCustomFormResponse } from '@src/@data/types/customForms';

const companyCustomFormsApi = {
  async getCustomForm(
    companyId: string,
    formId: string
  ): Promise<CompanyCustomFormResponse> {
    return apiAxios
      .get(`/api/portal/company/${companyId}/forms/${formId}`)
      .then(handleResponse);
  },
};

export default companyCustomFormsApi;
